import React from 'react';
import ImprintHero from './ImprintHero';
import { Box } from '@chakra-ui/react';
import BaseContainer from '@/components/BaseContainer';
import Reveal from '../HomeContainer/Reveal';
import Data from './Data';
import { colors } from '@/styles/theme/colors';

type Component = {
  id: string;
  component: JSX.Element;
  bgColor: string;
  animate: boolean;
  container: boolean;
};

const components: Component[] = [
  {
    id: 'imprinthero',
    component: <ImprintHero />,
    bgColor: colors.diment.lightGrey,
    animate: true,
    container: false,
  },
  {
    id: 'data',
    component: <Data />,
    bgColor: colors.diment.lightGrey,
    animate: true,
    container: false,
  },
];

const ImprintContainer = () => {
  return (
    <>
      {components.map((item, index) => {
        return (
          <Box key={item.id} bgColor={item.bgColor} w='full'>
            {item.container ? (
              <BaseContainer>
                <Reveal animate={item.animate}>{item.component}</Reveal>
              </BaseContainer>
            ) : (
              <Reveal animate={item.animate}>{item.component}</Reveal>
            )}
          </Box>
        );
      })}
    </>
  );
};

export default ImprintContainer;
